<template>
  <PanelGroup>
    <div
      style="height: calc(100vh - 422px)"
      class="overflow-y-auto w-full form"
    >
      <div class="flex flex-col">
        <div class="py-2 align-middle inline-block min-w-full">
          <div class="overflow-hidden sm:rounded-lg">
            <data-table
              :items="inventory"
              :headers="headers"
              :selectable="false"
              :actions="[]"
            >
              <template v-slot:rows="table">
                <inventory-row
                  v-bind="table"
                  :selectable="false"
                  :show-route="packageShowRoute"
                  @edit="goto(table.item)"
                  @inspect="() => openInspector(table.item)"
                />
              </template>
            </data-table>
          </div>
        </div>
      </div>
    </div>
    <template #bottom>
      <FloatPanel
        :open="Boolean(inspectedItem)"
        @clickOutside="closeInspector"
        location="bottom"
        height="500px"
        class="custom-shadow bg-gray-100"
      >
        <div
          v-if="inspectedItem"
          class="flex divide-x h-full"
        >
          <div class="flex-1 pl-10 pt-10">
            <h2 class="text-blue-600 text-lg font-bold">
              Locations - <span class="text-sm">{{ inspectedItem.name }}</span>
            </h2>
            <table class="text-left table-auto w-full mt-8 border-t">
              <thead>
                <tr class="text-xs text-gray-400 uppercase">
                  <th class="py-4">Name</th>
                  <th>Batch Quantity</th>
                  <th>Total Stock</th>
                  <th>Total Avail.</th>
                  <th>Sell Thru</th>
                  <th>Stock Out</th>
                </tr>
              </thead>
              <tbody class="divide-y-4 divide-gray-200">
                <tr
                  v-for="location in packageData.locations"
                  :key="location.id"
                >
                  <td class="font-bold py-3">{{ location.name }}</td>
                  <td>{{ location.batch_qty }}</td>
                  <td>{{ location.total_stock }}</td>
                  <td>{{ location.total_avail }}</td>
                  <td>{{ location.sell_thru }}</td>
                  <td>{{ location.stock_out }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="flex-1 max-w-md pt-10">
            <h2 class="text-blue-600 text-lg font-bold pl-10">Selling</h2>
            <table class="table-auto w-full mt-8 border-t">
              <thead>
                <tr class="text-xs text-gray-400 uppercase">
                  <th class="py-4">Retail</th>
                  <th>Ecommerce</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="location in packageData.locations"
                  :key="location.id"
                  class="text-center"
                >
                  <td class="font-bold py-2">
                    <div
                      class="inline-flex gap-x-2 rounded-full border py-1 px-2 items-center w-36"
                      :class="[location.retail ? 'bg-blue-600 text-gray-100' : 'border-gray-400 text-gray-400']"
                    >
                      <CheckCircleIcon class="h-6 w-6 shrink-0" />
                      <span v-if="!location.retail">Inactive</span>
                      <span v-if="location.retail">Available</span>
                    </div>
                  </td>
                  <td>
                    <div
                      class="inline-flex gap-x-2 rounded-full border py-1 px-2 items-center w-36"
                      :class="[location.ecom ? 'bg-blue-600 text-gray-100' : 'border-gray-400 text-gray-400']"
                    >
                      <CheckCircleIcon class="h-6 w-6 shrink-0" />
                      <span v-if="!location.ecom">Inactive</span>
                      <span v-if="location.ecom">Available</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </FloatPanel>
    </template>
  </PanelGroup>
</template>

<style scoped>
.custom-shadow {
  box-shadow: -2px -11px 11px -1px rgba(0, 0, 0, 0.03);
}
</style>
<script setup>
import packageData from '@/Components/test-package-data.json'
import DataTable from '@/Components/Table/DataTable'
import InventoryRow from '@/Pages/Products/Components/InventoryRow'
import { PanelGroup, FloatPanel } from '@/Components/Panels'
import { CheckCircleIcon } from '@heroicons/vue/outline'

import { ref } from 'vue'

const props = defineProps({
  inventory: {
    type: Array,
    default() {
      return []
    }
  }
})

const emits = defineEmits(['edit'])

const headers = ref(['Name', 'Batch #', 'Tag #', 'Lot #', 'Total QTY', 'Publish Date', 'Status'])

const inspectedItem = ref(null)

function goto(item) {
  emits('edit', item)
}
function packageShowRoute(item) {
  return route('packages.show', { package: item.id })
}
function openInspector(item) {
  inspectedItem.value = item
}

function closeInspector() {
  inspectedItem.value = null
}
</script>
